import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  bulkUpdateCropDates,
  bulkUpdateCropYield,
  bulkUpdateMineralFertilizerPractice,
  bulkUpdateOrganicFertilizerPractice,
  bulkUpdateSeedingPractice,
  bulkUpdateTillagePractice,
} from "services";

import { applyUpdatedCropYieldsToCache, invalidateQueriesAfterFieldsBulkUpdate } from "utils";

import {
  UPDATE_BULK_CROP_DATES,
  UPDATE_BULK_CROP_MINERAL_FERTILIZER,
  UPDATE_BULK_CROP_ORGANIC_FERTILIZER,
  UPDATE_BULK_CROP_SEEDING,
  UPDATE_BULK_CROP_TILLAGE,
  UPDATE_BULK_CROP_YIELD,
} from "consts";

export const useBulkUpdateCropYield = ({ fieldIds }: { fieldIds: string[] }) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [UPDATE_BULK_CROP_YIELD],
    mutationFn: bulkUpdateCropYield,
    onSuccess: ({ updatedCrops = [] }) => {
      applyUpdatedCropYieldsToCache(queryClient, updatedCrops);
      invalidateQueriesAfterFieldsBulkUpdate(queryClient, fieldIds);
    },
  });
};

export const useBulkUpdateCropSeedingPractice = ({ fieldIds }: { fieldIds: string[] }) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [UPDATE_BULK_CROP_SEEDING],
    mutationFn: bulkUpdateSeedingPractice,
    onSuccess: () => {
      invalidateQueriesAfterFieldsBulkUpdate(queryClient, fieldIds);
    },
  });
};

export const useBulkUpdateOrganicFertilizerPractice = ({ fieldIds }: { fieldIds: string[] }) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [UPDATE_BULK_CROP_ORGANIC_FERTILIZER],
    mutationFn: bulkUpdateOrganicFertilizerPractice,
    onSuccess: () => {
      invalidateQueriesAfterFieldsBulkUpdate(queryClient, fieldIds);
    },
  });
};

export const useBulkUpdateMineralFertilizerPractice = ({ fieldIds }: { fieldIds: string[] }) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [UPDATE_BULK_CROP_MINERAL_FERTILIZER],
    mutationFn: bulkUpdateMineralFertilizerPractice,
    onSuccess: () => {
      invalidateQueriesAfterFieldsBulkUpdate(queryClient, fieldIds);
    },
  });
};

export const useBulkUpdateTillagePractice = ({ fieldIds }: { fieldIds: string[] }) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [UPDATE_BULK_CROP_TILLAGE],
    mutationFn: bulkUpdateTillagePractice,
    onSuccess: () => {
      invalidateQueriesAfterFieldsBulkUpdate(queryClient, fieldIds);
    },
  });
};

export const useBulkUpdateCropDates = ({ fieldIds }: { fieldIds: string[] }) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [UPDATE_BULK_CROP_DATES],
    mutationFn: bulkUpdateCropDates,
    onSuccess: () => {
      invalidateQueriesAfterFieldsBulkUpdate(queryClient, fieldIds);
    },
  });
};
